import { QUICK_INTEGRATION_CONTINUE, QUICK_INTEGRATION_SAVE_ASYNC } from './constants'

const continueQuickIntegration = (data) => ({
  type: QUICK_INTEGRATION_CONTINUE,
  payload: { data },
})

export const saveQuickIntegration = (data) => ({
  type: QUICK_INTEGRATION_SAVE_ASYNC.INITIATE,
  payload: { data },
})
export const saveQuickIntegrationSuccess = () => ({
  type: QUICK_INTEGRATION_SAVE_ASYNC.SUCCESS,
})
export const saveQuickIntegrationError = (error) => ({
  type: QUICK_INTEGRATION_SAVE_ASYNC.ERROR,
  error,
})

export default {
  // to props
  saveQuickIntegration,
  continueQuickIntegration,
}
